import { z } from 'zod';

export const TEAM_QUANTITY_MIN = 2;
export const TEAM_QUANTITY_MAX = 50;

export const formalDegreeKeySchema = z.enum(['ms_ai', 'mba_ai']);
export type FormalDegreeKey = z.infer<typeof formalDegreeKeySchema>;

export const DEGREE_CONFIG: Record<
  FormalDegreeKey,
  {
    readonly title: string;
    readonly panelHeading: string;
    readonly subscriptionDescription: string;
    readonly theme: 'blue' | 'crimson';
  }
> = {
  ms_ai: {
    title: "Checkout for Master's in AI",
    panelHeading: "Master's degree in AI",
    subscriptionDescription: "Access to 500+ programs including all master's programs.",
    theme: 'blue',
  },
  mba_ai: {
    title: 'Checkout for MBA in AI',
    panelHeading: 'MBA in AI Product Management',
    subscriptionDescription: 'Access to 500+ programs including all MBA programs.',
    theme: 'crimson',
  },
};
